<template>
  <div class="container">

    <div class="sidebar">
      <aside class="menu">
        <p class="menu-label">Catégories</p>
        <ul class="menu-list">
          <ProprietaireSidebarClass
            v-for="category in categories"
            :key="category.id"
            :category="category"
            :current.sync="currentCategory"
          />
        </ul>
      </aside>
    </div>

    <div class="right">
      <ProprietaireDocuments/>
    </div>

  </div>
</template>

<script>
const categories = [
  {
    id: 1,
    name: 'Assurances Propriétaires',
  },
  {
    id: 2,
    name: 'Autorisations d\'Urbanisme & Commerciales',
  },
  {
    id: 3,
    name: 'Baux',
  },
  {
    id: 4,
    name: 'Conformité',
  },
  {
    id: 11,
    name: 'Dommage Ouvrage',
    parent: 1,
  },
  {
    id: 12,
    name: 'Multirisques & Responsabilité civile',
    parent: 1,
  },
  {
    id: 21,
    name: 'Autorisations Administratives de travaux',
    parent: 2,
  },
  {
    id: 22,
    name: 'DIUO & RVRAT',
    parent: 2,
  },
  {
    id: 23,
    name: 'DOE',
    parent: 2,
  },
  {
    id: 24,
    name: 'PVRT & PVLR',
    parent: 2,
  },
  {
    id: 25,
    name: 'RICT & RFCT',
    parent: 2,
  },
  {
    id: 26,
    name: 'Urbanisme commercial',
    parent: 2,
  },
  {
    id: 31,
    name: 'Actes contractuels',
    parent: 3,
  },
  {
    id: 32,
    name: 'Correspondances',
    parent: 3,
  },
  {
    id: 33,
    name: 'Pièces comptables',
    parent: 3,
  },
  {
    id: 41,
    name: 'Assainissement & LEMA',
    parent: 4,
  },
  {
    id: 42,
    name: 'Autres rapports & Diagnostics',
    parent: 4,
  },
  {
    id: 43,
    name: 'ERP - Exploitation et Etablissement Recevant du Public',
    parent: 4,
  },
  {
    id: 44,
    name: 'ICPE',
    parent: 4,
  },
  {
    id: 45,
    name: 'Rapports périodiques',
    parent: 4,
  },
]

import ProprietaireDocuments from '@/components/Proprietaire/Documents'
import ProprietaireSidebarClass from '@/components/Proprietaire/SidebarClass'

export default {
  components: {
    ProprietaireDocuments,
    ProprietaireSidebarClass,
  },
  data () {
    return {
      currentCategory: null,
    }
  },
  computed: {
    categories () {
      return categories.filter(i => !i.parent).map(category => ({
        ...category,
        subCategories: categories.filter(i => i.parent === category.id)
      }))
    },
  },
  mounted () {
    if (this.categories.length > 0) {
      this.currentCategory = this.categories[0].id
    }
  },
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  padding: 2em 1em;
  background: #fff;
  min-height: 100%;
}
.sidebar {
  width: 200px;
  flex-shrink: 0;
  margin-right: 1em;
}
.right {
  flex-grow: 1;
}
</style>
